import type { IpttqRecord } from '@kelilearning/psycheflow-contracts';

const TTL_MS = 10 * 60 * 1000;

const cache = new Map<string, { expiresAt: number; record: IpttqRecord }>();

function cloneRecord(record: IpttqRecord): IpttqRecord {
  return {
    ...record,
    bankParticleIds: Array.isArray(record.bankParticleIds) ? [...record.bankParticleIds] : record.bankParticleIds,
    skill: record.skill ? { ...record.skill } : record.skill,
  };
}

export function peekIpttqRecord(ipttqId: string): IpttqRecord | null {
  const id = String(ipttqId || '').trim();
  if (!id) return null;
  const entry = cache.get(id);
  if (!entry || entry.expiresAt <= Date.now()) {
    if (entry) cache.delete(id);
    return null;
  }
  return cloneRecord(entry.record);
}

export function rememberIpttqRecord(record: IpttqRecord | null | undefined): IpttqRecord | null {
  if (!record?.id) return record ?? null;
  cache.set(record.id, {
    expiresAt: Date.now() + TTL_MS,
    record: cloneRecord(record),
  });
  return record;
}

export function invalidateIpttqRecord(ipttqId?: string) {
  if (!ipttqId) {
    cache.clear();
    return;
  }
  cache.delete(String(ipttqId).trim());
}

export function seedIpttqRecordsFromSession(records: IpttqRecord[] | null | undefined) {
  if (!Array.isArray(records)) return;
  for (const record of records) {
    if (!record?.id) continue;
    const existing = peekIpttqRecord(record.id);
    if (existing && (existing.bankParticleIds?.length || 0) >= (record.bankParticleIds?.length || 0)) {
      continue;
    }
    rememberIpttqRecord(record);
  }
}
